import RichiestaEffect from "./RichiestaEffect";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import ActionUtility from "../../utilities/ActionUtility";
import { ReduxDispatch } from "../../models/ReduxProps";
import RichiestaModel from "./models/RichiestaModel";
import ResponseEsitoModel from "stores/shared/models/ResponseEsitoModel";
import RichiestaDatiAnagraficiRequestModel from "./models/RichiestaDatiAnagraficiRequestModel";
import RichiestaDatiRedditoRequestModel from "./models/RichiestaDatiRedditoRequestModel";
import RichiestaAltriPrestitiRequestModel from "./models/RichiestaAltriPrestitiRequestModel";
import RichiestaDocumentoViewModel from "./models/RichiestaDocumentoViewModel";
import RichiestaDocumentoRequestModel from "./models/RichiestaDocumentoRequestModel";
import ResponseStatoModel from "../shared/models/ResponseStatoModel";
import CqsOnlineRichiestaSezioneDocumentiViewModel from "stores/cqsonline/models/CqsOnlineRichiestaSezioneDocumentiViewModel";
import CqsOnlineRichiestaUploadDocumentoRequestModel from "stores/cqsonline/models/CqsOnlineRichiestaUploadDocumentoRequestModel";
import RichiestaConcludiRequestModel from "./models/RichiestaConcludiRequestModel";
import PreventivoQuestionarioModel from "stores/preventivo/models/PreventivoQuestionarioModel";
import NuovoImpegnoModel from "stores/preventivo/models/NuovoImpegnoModel";
import RicercaPreventivoViewModel from "stores/preventivo/models/RicercaPreventivoViewModel";
import RichiestaAdeguataVerificaRequestModel from "./models/RichiestaAdeguataVerificaRequestModel";
import NuovoImpegnoViewModel from "stores/preventivo/models/NuovoImpegnoViewModel";

type ActionUnion =
    | undefined
    | HttpErrorResponseModel
    | RichiestaModel
    | RichiestaDatiAnagraficiRequestModel
    | RichiestaDatiRedditoRequestModel
    | RichiestaAltriPrestitiRequestModel
    | ResponseEsitoModel
    | RichiestaDocumentoViewModel[]
    | Blob
    | ResponseStatoModel
    | CqsOnlineRichiestaSezioneDocumentiViewModel[]
    | RichiestaConcludiRequestModel
    | PreventivoQuestionarioModel
    | NuovoImpegnoModel[]
    | RicercaPreventivoViewModel
    | RichiestaAdeguataVerificaRequestModel;

export default class RichiestaAction {
    public static readonly VERIFICA_RICHIESTA: string = "RichiestaAction.REQUEST_VERIFICA_RICHIESTA";
    public static readonly VERIFICA_RICHIESTA_FINISHED: string = "RichiestaAction.REQUEST_VERIFICA_RICHIESTA_FINISHED";

    public static readonly REQUEST_RICHIESTA: string = "RichiestaAction.REQUEST_RICHIESTA";
    public static readonly REQUEST_RICHIESTA_FINISHED: string = "RichiestaAction.REQUEST_RICHIESTA_FINISHED";

    public static readonly SAVE_STEP_RICHIESTA: string = "RichiestaAction.REQUEST_SAVE_STEP_RICHIESTA";
    public static readonly SAVE_STEP_RICHIESTA_FINISHED: string =
        "RichiestaAction.REQUEST_SAVE_STEP_RICHIESTA_FINISHED";

    public static readonly DOWNLOAD_PIANO_AMMORTAMENTO: string = "RichiestaAction.REQUEST_DOWNLOAD_PIANO_AMMORTAMENTO";
    public static readonly DOWNLOAD_PIANO_AMMORTAMENTO_FINISHED: string =
        "RichiestaAction.REQUEST_DOWNLOAD_PIANO_AMMORTAMENTO_FINISHED";

    public static readonly REQUEST_DATI_ANAGRAFICI: string = "RichiestaAction.REQUEST_DATI_ANAGRAFICI";
    public static readonly REQUEST_DATI_ANAGRAFICI_FINISHED: string =
        "RichiestaAction.REQUEST_DATI_ANAGRAFICI_FINISHED";

    public static readonly SAVE_DATI_ANAGRAFICI: string = "RichiestaAction.REQUEST_SAVE_DATI_ANAGRAFICI";
    public static readonly SAVE_DATI_ANAGRAFICI_FINISHED: string =
        "RichiestaAction.REQUEST_SAVE_DATI_ANAGRAFICI_FINISHED";

    public static readonly REQUEST_DATI_REDDITO: string = "RichiestaAction.REQUEST_DATI_REDDITO";
    public static readonly REQUEST_DATI_REDDITO_FINISHED: string = "RichiestaAction.REQUEST_DATI_REDDITO_FINISHED";

    public static readonly SAVE_DATI_REDDITO: string = "RichiestaAction.REQUEST_SAVE_DATI_REDDITO";
    public static readonly SAVE_DATI_REDDITO_FINISHED: string = "RichiestaAction.REQUEST_SAVE_DATI_REDDITO_FINISHED";

    public static readonly REQUEST_ALTRI_PRESTITI: string = "RichiestaAction.REQUEST_ALTRI_PRESTITI";
    public static readonly REQUEST_ALTRI_PRESTITI_FINISHED: string = "RichiestaAction.REQUEST_ALTRI_PRESTITI_FINISHED";

    public static readonly SAVE_ALTRI_PRESTITI: string = "RichiestaAction.REQUEST_SAVE_ALTRI_PRESTITI";
    public static readonly SAVE_ALTRI_PRESTITI_FINISHED: string =
        "RichiestaAction.REQUEST_SAVE_ALTRI_PRESTITI_FINISHED";

    public static readonly REQUEST_DOCUMENTI_FIRMA_DEBOLE: string = "RichiestaAction.REQUEST_DOCUMENTI_FIRMA_DEBOLE";
    public static readonly REQUEST_DOCUMENTI_FIRMA_DEBOLE_FINISHED: string =
        "RichiestaAction.REQUEST_DOCUMENTI_FIRMA_DEBOLE_FINISHED";

    public static readonly REQUEST_DOCUMENTI_FIRMA_FORTE: string = "RichiestaAction.REQUEST_DOCUMENTI_FIRMA_FORTE";
    public static readonly REQUEST_DOCUMENTI_FIRMA_FORTE_FINISHED: string =
        "RichiestaAction.REQUEST_DOCUMENTI_FIRMA_FORTE_FINISHED";

    public static readonly UPLOAD_DOCUMENTO: string = "RichiestaAction.REQUEST_UPLOAD_DOCUMENTO";
    public static readonly UPLOAD_DOCUMENTO_FINISHED: string = "RichiestaAction.REQUEST_UPLOAD_DOCUMENTO_FINISHED";

    public static readonly DOWNLOAD_DOCUMENTO: string = "RichiestaAction.REQUEST_DOWNLOAD_DOCUMENTO";
    public static readonly DOWNLOAD_DOCUMENTO_FINISHED: string = "RichiestaAction.REQUEST_DOWNLOAD_DOCUMENTO_FINISHED";

    public static readonly DELETE_DOCUMENTO: string = "RichiestaAction.REQUEST_DELETE_DOCUMENTO";
    public static readonly DELETE_DOCUMENTO_FINISHED: string = "RichiestaAction.REQUEST_DELETE_DOCUMENTO_FINISHED";

    public static readonly REQUEST_AVVIA_PROCESSO_FIRMA_DEBOLE: string =
        "RichiestaAction.REQUEST_AVVIA_PROCESSO_FIRMA_DEBOLE";
    public static readonly REQUEST_AVVIA_PROCESSO_FIRMA_DEBOLE_FINISHED: string =
        "RichiestaAction.REQUEST_AVVIA_PROCESSO_FIRMA_DEBOLE_FINISHED";

    public static readonly REQUEST_ANNULLA_PROCESSO_FIRMA_DEBOLE: string =
        "RichiestaAction.REQUEST_ANNULLA_PROCESSO_FIRMA_DEBOLE";
    public static readonly REQUEST_ANNULLA_PROCESSO_FIRMA_DEBOLE_FINISHED: string =
        "RichiestaAction.REQUEST_ANNULLA_PROCESSO_FIRMA_DEBOLE_FINISHED";

    public static readonly REQUEST_STATO_PROCESSO_FIRMA_DEBOLE: string =
        "RichiestaAction.REQUEST_STATO_PROCESSO_FIRMA_DEBOLE";
    public static readonly REQUEST_STATO_PROCESSO_FIRMA_DEBOLE_FINISHED: string =
        "RichiestaAction.REQUEST_STATO_PROCESSO_FIRMA_DEBOLE_FINISHED";

    public static readonly REQUEST_AVVIA_PROCESSO_FIRMA_FORTE: string =
        "RichiestaAction.REQUEST_AVVIA_PROCESSO_FIRMA_FORTE";
    public static readonly REQUEST_AVVIA_PROCESSO_FIRMA_FORTE_FINISHED: string =
        "RichiestaAction.REQUEST_AVVIA_PROCESSO_FIRMA_FORTE_FINISHED";

    public static readonly REQUEST_ANNULLA_PROCESSO_FIRMA_FORTE: string =
        "RichiestaAction.REQUEST_ANNULLA_PROCESSO_FIRMA_FORTE";
    public static readonly REQUEST_ANNULLA_PROCESSO_FIRMA_FORTE_FINISHED: string =
        "RichiestaAction.REQUEST_ANNULLA_PROCESSO_FIRMA_FORTE_FINISHED";

    public static readonly REQUEST_STATO_PROCESSO_FIRMA_FORTE: string =
        "RichiestaAction.REQUEST_STATO_PROCESSO_FIRMA_FORTE";
    public static readonly REQUEST_STATO_PROCESSO_FIRMA_FORTE_FINISHED: string =
        "RichiestaAction.REQUEST_STATO_PROCESSO_FIRMA_FORTE_FINISHED";

    public static readonly REQUEST_AVVIA_PROCESSO_RICONOSCIMENTO: string =
        "RichiestaAction.REQUEST_AVVIA_PROCESSO_RICONOSCIMENTO";
    public static readonly REQUEST_AVVIA_PROCESSO_RICONOSCIMENTO_FINISHED: string =
        "RichiestaAction.REQUEST_AVVIA_PROCESSO_RICONOSCIMENTO_FINISHED";

    // public static readonly REQUEST_ANNULLA_PROCESSO_RICONOSCIMENTO: string =
    //     "RichiestaAction.REQUEST_ANNULLA_PROCESSO_RICONOSCIMENTO";
    // public static readonly REQUEST_ANNULLA_PROCESSO_RICONOSCIMENTO_FINISHED: string =
    //     "RichiestaAction.REQUEST_ANNULLA_PROCESSO_RICONOSCIMENTO_FINISHED";

    /*    public static readonly REQUEST_STATO_PROCESSO_RICONOSCIMENTO: string =
        "RichiestaAction.REQUEST_STATO_PROCESSO_RICONOSCIMENTO";
    public static readonly REQUEST_STATO_PROCESSO_RICONOSCIMENTO_FINISHED: string =
        "RichiestaAction.REQUEST_STATO_PROCESSO_RICONOSCIMENTO_FINISHED"; */

    // #region CQS online
    public static readonly REQUEST_DOCUMENTI_DA_CARICARE_CQSOL: string =
        "RichiestaAction.REQUEST_DOCUMENTI_DA_CARICARE_CQSOL";
    public static readonly REQUEST_DOCUMENTI_DA_CARICARE_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_DOCUMENTI_DA_CARICARE_CQSOL_FINISHED";

    public static readonly REQUEST_DOCUMENTI_DA_FIRMARE_CQSOL: string =
        "RichiestaAction.REQUEST_DOCUMENTI_DA_FIRMARE_CQSOL";
    public static readonly REQUEST_DOCUMENTI_DA_FIRMARE_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_DOCUMENTI_DA_FIRMARE_CQSOL_FINISHED";

    public static readonly REQUEST_STATO_FIRMA_CQSOL: string = "RichiestaAction.REQUEST_STATO_FIRMA_CQSOL";
    public static readonly REQUEST_STATO_FIRMA_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_STATO_FIRMA_CQSOL_FINISHED";

    public static readonly UPLOAD_DOCUMENTO_CQSOL: string = "RichiestaAction.REQUEST_UPLOAD_DOCUMENTO_CQSOL";
    public static readonly UPLOAD_DOCUMENTO_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_UPLOAD_DOCUMENTO_CQSOL_FINISHED";

    public static readonly SAVE_SEZIONE_DOCUMENTI_CQSOL: string =
        "RichiestaAction.REQUEST_SAVE_SEZIONE_DOCUMENTI_CQSOL";
    public static readonly SAVE_SEZIONE_DOCUMENTI_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_SAVE_SEZIONE_DOCUMENTI_CQSOL_FINISHED";

    public static readonly DOWNLOAD_DOCUMENTO_CQSOL: string = "RichiestaAction.REQUEST_DOWNLOAD_DOCUMENTO_CQSOL";
    public static readonly DOWNLOAD_DOCUMENTO_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_DOWNLOAD_DOCUMENTO_CQSOL_FINISHED";

    public static readonly DELETE_DOCUMENTO_CQSOL: string = "RichiestaAction.REQUEST_DELETE_DOCUMENTO_CQSOL";
    public static readonly DELETE_DOCUMENTO_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_DELETE_DOCUMENTO_CQSOL_FINISHED";

    public static readonly REQUEST_AVVIA_PROCESSO_FIRMA_CQSOL: string =
        "RichiestaAction.REQUEST_AVVIA_PROCESSO_FIRMA_CQSOL";
    public static readonly REQUEST_AVVIA_PROCESSO_FIRMA_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_AVVIA_PROCESSO_FIRMA_CQSOL_FINISHED";

    public static readonly REQUEST_ANNULLA_PROCESSO_FIRMA_CQSOL: string =
        "RichiestaAction.REQUEST_ANNULLA_PROCESSO_FIRMA_CQSOL";
    public static readonly REQUEST_ANNULLA_PROCESSO_FIRMA_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_ANNULLA_PROCESSO_FIRMA_CQSOL_FINISHED";

    public static readonly REQUEST_AVVIA_PROCESSO_RICONOSCIMENTO_CQSOL: string =
        "RichiestaAction.REQUEST_AVVIA_PROCESSO_RICONOSCIMENTO_CQSOL";
    public static readonly REQUEST_AVVIA_PROCESSO_RICONOSCIMENTO_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_AVVIA_PROCESSO_RICONOSCIMENTO_CQSOL_FINISHED";

    public static readonly REQUEST_ANNULLA_PROCESSO_RICONOSCIMENTO_CQSOL: string =
        "RichiestaAction.REQUEST_ANNULLA_PROCESSO_RICONOSCIMENTO_CQSOL";
    public static readonly REQUEST_ANNULLA_PROCESSO_RICONOSCIMENTO_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_ANNULLA_PROCESSO_RICONOSCIMENTO_CQSOL_FINISHED";

    public static readonly REQUEST_STATO_PROCESSO_RICONOSCIMENTO_CQSOL: string =
        "RichiestaAction.REQUEST_STATO_PROCESSO_RICONOSCIMENTO_CQSOL";
    public static readonly REQUEST_STATO_PROCESSO_RICONOSCIMENTO_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_STATO_PROCESSO_RICONOSCIMENTO_CQSOL_FINISHED";

    public static readonly REQUEST_CHECK_PREVENTIVO_CQSOL: string = "RichiestaAction.REQUEST_CHECK_PREVENTIVO_CQSOL";
    public static readonly REQUEST_CHECK_PREVENTIVO_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_CHECK_PREVENTIVO_CQSOL_FINISHED";

    public static readonly REQUEST_CANCELLA_PREVENTIVO_RICHIESTA_CQSOL: string =
        "RichiestaAction.REQUEST_CANCELLA_PREVENTIVO_RICHIESTA_CQSOL";
    public static readonly REQUEST_CANCELLA_PREVENTIVO_RICHIESTA_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_CANCELLA_PREVENTIVO_RICHIESTA_CQSOL_FINISHED";

    public static readonly REQUEST_DOCUMENTI_ISTRUTTORIA_DA_FIRMARE_CQSOL: string =
        "RichiestaAction.REQUEST_DOCUMENTI_ISTRUTTORIA_DA_FIRMARE_CQSOL";
    public static readonly REQUEST_DOCUMENTI_ISTRUTTORIA_DA_FIRMARE_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_DOCUMENTI_ISTRUTTORIA_DA_FIRMARE_CQSOL_FINISHED";

    public static readonly REQUEST_CONCLUDI_DICHIARAZIONI_CQSOL: string =
        "RichiestaAction.REQUEST_CONCLUDI_DICHIARAZIONI_CQSOL";
    public static readonly REQUEST_CONCLUDI_DICHIARAZIONI_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_CONCLUDI_DICHIARAZIONI_CQSOL_FINISHED";

    public static readonly SAVE_CONCLUDI_DICHIARAZIONI_CQSOL: string =
        "RichiestaAction.SAVE_CONCLUDI_DICHIARAZIONI_CQSOL";
    public static readonly SAVE_CONCLUDI_DICHIARAZIONI_CQSOL_FINISHED: string =
        "RichiestaAction.SAVE_CONCLUDI_DICHIARAZIONI_CQSOL_FINISHED";

    public static readonly REQUEST_IMPEGNI_CQSOL: string = "RichiestaAction.REQUEST_IMPEGNI_CQSOL";
    public static readonly REQUEST_IMPEGNI_CQSOL_FINISHED: string = "RichiestaAction.REQUEST_IMPEGNI_CQSOL_FINISHED";

    public static readonly SAVE_IMPEGNI: string = "RichiestaAction.SAVE_IMPEGNI";
    public static readonly SAVE_IMPEGNI_FINISHED: string = "RichiestaAction.REQUEST_SAVE_IMPEGNI_FINISHED";

    public static readonly RESET_IMPEGNI: string = "PreventivoAction.RESET_IMPEGNI";
    public static readonly RESET_IMPEGNI_FINISHED: string = "PreventivoAction.RESET_IMPEGNI_FINISHED";

    public static readonly REQUEST_GET_FILTRI: string = "PreventivoAction.REQUEST_GET_FILTRI";
    public static readonly REQUEST_GET_FILTRI_FINISHED: string = "PreventivoAction.REQUEST_GET_FILTRI";

    public static readonly DELETE_DOCUMENTI_GENERATI_CQSOL: string =
        "RichiestaAction.REQUEST_DELETE_DOCUMENTI_GENERATI_CQSOL";
    public static readonly DELETE_DOCUMENTI_GENERATI_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_DELETE_DOCUMENTI_GENERATI_CQSOL_FINISHED";

    public static readonly REQUEST_ADEGUATA_VERIFICA: string = "RichiestaAction.REQUEST_ADEGUATA_VERIFICA";
    public static readonly REQUEST_ADEGUATA_VERIFICA_FINISHED: string =
        "RichiestaAction.REQUEST_ADEGUATA_VERIFICA_FINISHED";

    public static readonly REQUEST_SAVE_ADEGUATA_VERIFICA: string = "RichiestaAction.REQUEST_SAVE_ADEGUATA_VERIFICA";
    public static readonly REQUEST_SAVE_ADEGUATA_VERIFICA_FINISHED: string =
        "RichiestaAction.REQUEST_SAVE_ADEGUATA_VERIFICA_FINISHED";
    // public static readonly REQUEST_ADEGUATA_VERIFICA: string = "RichiestaAction.REQUEST_ADEGUATA_VERIFICA";
    // public static readonly REQUEST_ADEGUATA_VERIFICA_FINISHED: string =
    //     "RichiestaAction.REQUEST_ADEGUATA_VERIFICA_FINISHED";

    // public static readonly REQUEST_SAVE_ADEGUATA_VERIFICA: string = "RichiestaAction.REQUEST_SAVE_ADEGUATA_VERIFICA";
    // public static readonly REQUEST_SAVE_ADEGUATA_VERIFICA_FINISHED: string =
    //     "RichiestaAction.REQUEST_SAVE_ADEGUATA_VERIFICA_FINISHED";

    public static readonly DELETE_IMPEGNI: string = "RichiestaAction.DELETE_IMPEGNI";
    public static readonly DELETE_IMPEGNI_FINISHED: string = "RichiestaAction.DELETE_IMPEGNI_FINISHED";

    public static readonly TRASFERISCI_DOC_CONSENSI_CQSWEB: string = "RichiestaAction.TRASFERISCI_DOC_CONSENSI_CQSWEB";
    public static readonly TRASFERISCI_DOC_CONSENSI_CQSWEB_FINISHED: string =
        "RichiestaAction.TRASFERISCI_DOC_CONSENSI_CQSWEB_FINISHED";
    // #endregion CQS online

    public static readonly REQUEST_ERROR: string = "RichiestaAction.REQUEST_ERROR";
    public static readonly REQUEST_ERROR_FINISHED: string = "RichiestaAction.REQUEST_ERROR_FINISHED";

    public static verificaRichiesta(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.VERIFICA_RICHIESTA,
                RichiestaEffect.verificaRichiesta
            );
        };
    }

    public static requestRichiesta(idRichiesta: number = 0): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<RichiestaModel>(
                dispatch,
                RichiestaAction.REQUEST_RICHIESTA,
                RichiestaEffect.requestRichiesta,
                idRichiesta
            );
        };
    }

    public static saveStepRichiesta(idRichiesta: number, isSospensione: boolean, step: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.SAVE_STEP_RICHIESTA,
                RichiestaEffect.saveStepRichiesta,
                idRichiesta,
                isSospensione,
                step
            );
        };
    }

    public static downloadPianoAmmortamento(idPreventivo: number, progressHandler: (progress: number) => void): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<any> => {
            return await ActionUtility.createThunkEffect<Blob>(
                dispatch,
                RichiestaAction.DOWNLOAD_PIANO_AMMORTAMENTO,
                RichiestaEffect.downloadPianoAmmortamento,
                idPreventivo,
                progressHandler
            );
        };
    }

    public static requestDatiAnagrafici(codTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<RichiestaDatiAnagraficiRequestModel>(
                dispatch,
                RichiestaAction.REQUEST_DATI_ANAGRAFICI,
                RichiestaEffect.requestDatiAnagrafici,
                codTipoRichiedente
            );
        };
    }

    public static saveDatiAnagrafici(request: RichiestaDatiAnagraficiRequestModel): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.SAVE_DATI_ANAGRAFICI,
                RichiestaEffect.saveDatiAnagrafici,
                request
            );
        };
    }

    public static requestDatiReddito(codTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<RichiestaDatiRedditoRequestModel>(
                dispatch,
                RichiestaAction.REQUEST_DATI_REDDITO,
                RichiestaEffect.requestDatiReddito,
                codTipoRichiedente
            );
        };
    }

    public static saveDatiReddito(request: RichiestaDatiRedditoRequestModel): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.SAVE_DATI_REDDITO,
                RichiestaEffect.saveDatiReddito,
                request
            );
        };
    }

    public static requestAtriPrestiti(codTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<RichiestaAltriPrestitiRequestModel>(
                dispatch,
                RichiestaAction.REQUEST_ALTRI_PRESTITI,
                RichiestaEffect.requestAltriPrestiti,
                codTipoRichiedente
            );
        };
    }

    public static saveAltriPrestiti(request: RichiestaAltriPrestitiRequestModel): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.SAVE_ALTRI_PRESTITI,
                RichiestaEffect.saveAltriPrestiti,
                request
            );
        };
    }

    public static requestDocumentiFirmaDebole(codTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<RichiestaDocumentoViewModel[]>(
                dispatch,
                RichiestaAction.REQUEST_DOCUMENTI_FIRMA_DEBOLE,
                RichiestaEffect.requestDocumenti,
                codTipoRichiedente,
                "D"
            );
        };
    }

    public static requestDocumentiFirmaForte(codTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<RichiestaDocumentoViewModel[]>(
                dispatch,
                RichiestaAction.REQUEST_DOCUMENTI_FIRMA_FORTE,
                RichiestaEffect.requestDocumenti,
                codTipoRichiedente,
                "F"
            );
        };
    }

    public static uploadDocumento(
        request: RichiestaDocumentoRequestModel,
        progressHandler: (progress: number) => void
    ): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.UPLOAD_DOCUMENTO,
                RichiestaEffect.uploadDocumento,
                request,
                progressHandler
            );
        };
    }

    public static downloadDocumento(idDocumento: number, progressHandler: (progress: number) => void): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<any> => {
            return await ActionUtility.createThunkEffect<Blob>(
                dispatch,
                RichiestaAction.DOWNLOAD_DOCUMENTO,
                RichiestaEffect.downloadDocumento,
                idDocumento,
                progressHandler
            );
        };
    }

    public static deleteDocumento(idDocumento: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.DELETE_DOCUMENTO,
                RichiestaEffect.deleteDocumento,
                idDocumento
            );
        };
    }

    public static requestAvviaProcessoFirmaDebole(codTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.REQUEST_AVVIA_PROCESSO_FIRMA_DEBOLE,
                RichiestaEffect.requestAvviaProcessoFirma,
                codTipoRichiedente,
                "D"
            );
        };
    }

    public static requestAnnullaProcessoFirmaDebole(codTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.REQUEST_ANNULLA_PROCESSO_FIRMA_DEBOLE,
                RichiestaEffect.requestAnnullaProcessoFirma,
                codTipoRichiedente,
                "D"
            );
        };
    }

    public static requestStatoProcessoFirmaDebole(codTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseStatoModel>(
                dispatch,
                RichiestaAction.REQUEST_STATO_PROCESSO_FIRMA_DEBOLE,
                RichiestaEffect.requestStatoProcessoFirma,
                codTipoRichiedente,
                "D"
            );
        };
    }

    public static requestAvviaProcessoFirmaForte(codTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.REQUEST_AVVIA_PROCESSO_FIRMA_FORTE,
                RichiestaEffect.requestAvviaProcessoFirma,
                codTipoRichiedente,
                "F"
            );
        };
    }

    public static requestAnnullaProcessoFirmaForte(codTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.REQUEST_ANNULLA_PROCESSO_FIRMA_FORTE,
                RichiestaEffect.requestAnnullaProcessoFirma,
                codTipoRichiedente,
                "F"
            );
        };
    }

    public static requestStatoProcessoFirmaForte(codTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseStatoModel>(
                dispatch,
                RichiestaAction.REQUEST_STATO_PROCESSO_FIRMA_FORTE,
                RichiestaEffect.requestStatoProcessoFirma,
                codTipoRichiedente,
                "F"
            );
        };
    }

    public static requestAvviaProcessoRiconoscimento(codTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.REQUEST_AVVIA_PROCESSO_RICONOSCIMENTO,
                RichiestaEffect.requestAvviaProcessoRiconoscimento,
                codTipoRichiedente
            );
        };
    }

    /*  public static requestAnnullaProcessoRiconoscimento(codTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.REQUEST_ANNULLA_PROCESSO_RICONOSCIMENTO,
                RichiestaEffect.requestAnnullaProcessoRiconoscimento,
                codTipoRichiedente
            );
        };
    } */

    /*   public static requestStatoProcessoRiconoscimento(codTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseStatoModel>(
                dispatch,
                RichiestaAction.REQUEST_STATO_PROCESSO_RICONOSCIMENTO,
                RichiestaEffect.requestStatoProcessoRiconoscimento,
                codTipoRichiedente
            );
        };
    } */
    // #region CQS online
    public static requestDocumentiDaCaricareCqsOnline(idPreventivo: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<CqsOnlineRichiestaSezioneDocumentiViewModel[]>(
                dispatch,
                RichiestaAction.REQUEST_DOCUMENTI_DA_CARICARE_CQSOL,
                RichiestaEffect.requestDocumentiDaCaricareCqsOnline,
                idPreventivo
            );
        };
    }

    public static requestDocumentiDaFirmareCqsOnline(idPreventivo: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<CqsOnlineRichiestaSezioneDocumentiViewModel[]>(
                dispatch,
                RichiestaAction.REQUEST_DOCUMENTI_DA_FIRMARE_CQSOL,
                RichiestaEffect.requestDocumentiDaFirmareCqsOnline,
                idPreventivo
            );
        };
    }

    public static requestStatoFirmaCqsOnline(idPreventivo: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseStatoModel>(
                dispatch,
                RichiestaAction.REQUEST_STATO_FIRMA_CQSOL,
                RichiestaEffect.requestStatoFirmaCqsOnline,
                idPreventivo
            );
        };
    }

    public static uploadDocumentoCqsOnline(
        request: CqsOnlineRichiestaUploadDocumentoRequestModel,
        progressHandler: (progress: number) => void
    ): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.UPLOAD_DOCUMENTO_CQSOL,
                RichiestaEffect.uploadDocumentoCqsOnline,
                request,
                progressHandler
            );
        };
    }

    public static saveSezioneDocumentiCqsOnline(
        idPreventivo: number,
        sezione: CqsOnlineRichiestaSezioneDocumentiViewModel
    ): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.SAVE_SEZIONE_DOCUMENTI_CQSOL,
                RichiestaEffect.saveSezioneDocumentiCqsOnline,
                idPreventivo,
                sezione
            );
        };
    }

    public static downloadDocumentoCqsOnline(
        idDocumento: number,
        isFirmato: boolean = false,
        progressHandler: (progress: number) => void
    ): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<any> => {
            return await ActionUtility.createThunkEffect<Blob>(
                dispatch,
                RichiestaAction.DOWNLOAD_DOCUMENTO_CQSOL,
                RichiestaEffect.downloadDocumentoCqsOnline,
                idDocumento,
                isFirmato,
                progressHandler
            );
        };
    }

    public static deleteDocumentoCqsOnline(idDocumento: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.DELETE_DOCUMENTO_CQSOL,
                RichiestaEffect.deleteDocumentoCqsOnline,
                idDocumento
            );
        };
    }

    public static requestAvviaProcessoFirmaCqsOnline(idPreventivo: number, idGruppo: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.REQUEST_AVVIA_PROCESSO_FIRMA_CQSOL,
                RichiestaEffect.requestAvviaProcessoFirmaCqsOnline,
                idPreventivo,
                idGruppo
            );
        };
    }

    public static requestAnnullaProcessoFirmaCqsOnline(idPreventivo: number, idGruppo: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.REQUEST_ANNULLA_PROCESSO_FIRMA_CQSOL,
                RichiestaEffect.requestAnnullaProcessoFirmaCqsOnline,
                idPreventivo,
                idGruppo
            );
        };
    }

    public static requestAvviaProcessoRiconoscimentoCqsOnline(idPreventivo: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.REQUEST_AVVIA_PROCESSO_RICONOSCIMENTO_CQSOL,
                RichiestaEffect.requestAvviaProcessoRiconoscimentoCqsOnline,
                idPreventivo
            );
        };
    }

    public static requestAnnullaProcessoRiconoscimentoCqsOnline(idPreventivo: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.REQUEST_ANNULLA_PROCESSO_RICONOSCIMENTO_CQSOL,
                RichiestaEffect.requestAnnullaProcessoRiconoscimentoCqsOnline,
                idPreventivo
            );
        };
    }

    public static requestStatoProcessoRiconoscimentoCqsOnline(idPreventivo: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseStatoModel>(
                dispatch,
                RichiestaAction.REQUEST_STATO_PROCESSO_RICONOSCIMENTO_CQSOL,
                RichiestaEffect.requestStatoProcessoRiconoscimentoCqsOnline,
                idPreventivo
            );
        };
    }

    public static requestCheckPreventivoCqsOnline(idPreventivo: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.REQUEST_CHECK_PREVENTIVO_CQSOL,
                RichiestaEffect.requestCheckPreventivoCqsOnline,
                idPreventivo
            );
        };
    }

    public static requestCancellaPreventivoRichiestaCqsOnline(idPreventivo: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.REQUEST_CANCELLA_PREVENTIVO_RICHIESTA_CQSOL,
                RichiestaEffect.requestCancellaPreventivoRichiestaCqsOnline,
                idPreventivo
            );
        };
    }

    public static requestDocumentiIstruttoriaDaFirmareCqsOnline(idPreventivo: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<CqsOnlineRichiestaSezioneDocumentiViewModel[]>(
                dispatch,
                RichiestaAction.REQUEST_DOCUMENTI_ISTRUTTORIA_DA_FIRMARE_CQSOL,
                RichiestaEffect.requestDocumentiIstruttoriaDaFirmareCqsOnline,
                idPreventivo
            );
        };
    }

    public static requestConcludi(idPreventivo: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<RichiestaConcludiRequestModel>(
                dispatch,
                RichiestaAction.REQUEST_CONCLUDI_DICHIARAZIONI_CQSOL,
                RichiestaEffect.requestConcludi,
                idPreventivo
            );
        };
    }

    public static saveConcludi(request: RichiestaConcludiRequestModel): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.SAVE_CONCLUDI_DICHIARAZIONI_CQSOL,
                RichiestaEffect.saveConcludi,
                request
            );
        };
    }

    public static requestGetImpegni(idUtente: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<NuovoImpegnoModel[]>(
                dispatch,
                RichiestaAction.REQUEST_IMPEGNI_CQSOL,
                RichiestaEffect.requestGetImpegni,
                idUtente
            );
        };
    }

    public static saveImpegni(impegni: NuovoImpegnoModel[]): any {
        //   console.log("Action " , impegni );
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.SAVE_IMPEGNI,
                RichiestaEffect.saveImpegni,
                impegni
            );
        };
    }

    public static resetFiltriImpegni(): any {
        return ActionUtility.createAction<any>(RichiestaAction.RESET_IMPEGNI_FINISHED);
    }

    public static deleteDocumentiGeneratiCqsOnline(idUtente: number, idPreventivo: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.DELETE_DOCUMENTI_GENERATI_CQSOL,
                RichiestaEffect.deleteDocumentiGeneratiCqsOnline,
                idUtente,
                idPreventivo
            );
        };
    }

    public static requestAdeguataVerifica(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<RichiestaAdeguataVerificaRequestModel>(
                dispatch,
                RichiestaAction.REQUEST_ADEGUATA_VERIFICA,
                RichiestaEffect.requestAdeguataVerifica
            );
        };
    }

    public static saveAdeguataVerifica(request: RichiestaAdeguataVerificaRequestModel): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.REQUEST_SAVE_ADEGUATA_VERIFICA,
                RichiestaEffect.saveAdeguataVerifica,
                request
            );
        };
    }

    public static deleteImpegni(idUtente: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.DELETE_IMPEGNI,
                RichiestaEffect.deleteImpegni,
                idUtente
            );
        };
    }

    public static requestTrasferisciDocumentiConsensiCqsWeb(idPreventivo: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                RichiestaAction.TRASFERISCI_DOC_CONSENSI_CQSWEB,
                RichiestaEffect.requestTrasferisciDocumentiConsensiCqsWeb,
                idPreventivo
            );
        };
    }
    // #endregion CQS online

    public static requestError(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<any>(
                dispatch,
                RichiestaAction.REQUEST_ERROR,
                RichiestaEffect.requestError
            );
        };
    }
}
